module.exports = __webpack_public_path__ + "img/user-address.6ac18168.svg";